import { Tooltip } from "antd";
import { FiWifiOff } from "react-icons/fi";

export const renderStatus = (status, t) => {
  // 0: online
  // 1: busy
  // 2: do not disturb
  // 3: back in few mintues
  // 4: away

  try {
    status = parseInt(status);

    switch (status) {
      case 0:
        return (
          <Tooltip title={t("status.available")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 bg-white dark:bg-gray-800 rounded-full p-0 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </Tooltip>
        );
      case 1:
        return (
          <Tooltip title={t("status.busy")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 bg-white dark:bg-gray-800 rounded-full p-0 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </Tooltip>
        );
      case 2:
        return (
          <Tooltip title={t("status.donotdisturb")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="h-4 w-4 bg-white dark:bg-gray-800 rounded-full p-0 text-gray-600 "
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          </Tooltip>
        );
      case 3:
        return (
          <Tooltip title={t("status.backInFewMin")} placement="topLeft">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 bg-white dark:bg-gray-800 rounded-full p-0 text-yellow-400 "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </Tooltip>
        );
      case 4:
        return (
          <Tooltip title={t("status.away")}>
            <svg
              style={{
                width: "18px",
                height: "18px",
              }}
              xmlns="http://www.w3.org/2000/svg"
              className=" bg-white dark:bg-gray-800 rounded-full p-0 text-yellow-400 "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </Tooltip>
        );

      case 5:
        return (
          <Tooltip title={t("status.offline")}>
            <FiWifiOff className=" h-4 w-4 animate-pulse   rounded-full" />
          </Tooltip>
        );

      default:
        return (
          <Tooltip title={t("status.offline")}>
            <FiWifiOff className=" h-4 w-4 animate-pulse   rounded-full" />
          </Tooltip>
        );
    }
  } catch (error) {
    return <></>;
  }
};
export function changeFavicon(path_ico) {
  const head = document.head || document.getElementsByTagName("head")[0];
  const oldFavicon = document.getElementById("favicon");

  if (oldFavicon) {
    head.removeChild(oldFavicon);
  }

  const newFavicon = document.createElement("link");
  newFavicon.id = "favicon";
  newFavicon.rel = "icon";
  newFavicon.href = process.env.PUBLIC_URL + path_ico;

  head.appendChild(newFavicon);
}
